export const COMMUNITY_DISCOUNT_TYPES = {
  NONE: 'NONE',
  MANAGER: 'MANAGER',
  ADJUSTMENT: 'ADJUSTMENT',
};

export const COMMUNITY_DISCOUNT_TYPES_TRANSLATE = {
  [COMMUNITY_DISCOUNT_TYPES.NONE]: '',
  [COMMUNITY_DISCOUNT_TYPES.MANAGER]: 'msg_manager',
  [COMMUNITY_DISCOUNT_TYPES.ADJUSTMENT]: 'msg_adjustment',
};

export const COMMUNITY_DISCOUNT_TYPES_FULL_NAME_TRANSLATE = {
  [COMMUNITY_DISCOUNT_TYPES.NONE]: '',
  [COMMUNITY_DISCOUNT_TYPES.MANAGER]: 'msg_manager_discount_comm_unity',
  [COMMUNITY_DISCOUNT_TYPES.ADJUSTMENT]: 'msg_adjustment_discount',
};
